import { Injectable } from '@angular/core';

declare var $: any;   // fix modal not a property of jQuery compile error

@Injectable()
export class GridService {
    getNewHeight(item, rowsCount, headerHeight, footerHeight, rowHeight, gridsCount) {
        if (item && item.parentNode && item.parentNode.parentNode && item.parentNode.parentNode.children) {

            let res: any = 0;

            if (item.parentNode.parentNode.children.length < 2) {
                // only one grid. make its height dynamic
                res = '75vh';
            } else {
                if (rowsCount < 1) {
                    res = headerHeight + footerHeight + rowHeight + 'px';
                } else {
                    if (rowsCount < 4) {
                        // empty grid or just 1 row. make its height fixed.
                        res = headerHeight + footerHeight + ((rowsCount + 1) * rowHeight) + 'px';
                    } else {
                        if (!gridsCount || (gridsCount < 1)) { gridsCount = 1; }

                        let vh = Math.floor(100 / gridsCount);
                        vh = vh < 25 ? 25 : vh;
                        res = vh + 'vh';
                    }
                }
            }

            return res;
        } else {
            return null;
        }
    }

    setupExpandRowThreshold(target) {
        if (target && (target.expandRowThreshold < 0)) {
            const item = target.table.columns ? target.table.columns : target.table.columnTemplates;
            if (item) {
                let temp = 0;
                for (let k = 0; k < item.length; k++) {
                    if (item[k].breakPoint) {
                        const px = parseInt('' + item[k].breakPoint);
                        if (!isNaN(px)) {
                            if (temp < px) { temp = px; }
                        }
                    }
                }
                target.expandRowThreshold = temp;
            } else {
            }
        }
    }

    doModal(heading, formContent) {
        // this is used in sales appointment grid for display error msg in popup
        // PRE: jquery is required
        let html = '<div id="dynamicModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirm-modal" aria-hidden="true">';
        html += '<div class="modal-dialog">';
        html += '<div class="modal-content">';
        html += '<div class="modal-header">';
        html += '<a class="close" data-dismiss="modal">×</a>';
        html += '<h4>' + heading + '</h4>';
        html += '</div>';
        html += '<div class="modal-body">';
        html += formContent;
        html += '</div>';
        html += '<div class="modal-footer">';
        html += '<span class="btn btn-primary" data-dismiss="modal">Close</span>';
        html += '</div>';  // content
        html += '</div>';  // dialog
        html += '</div>';  // footer
        html += '</div>';  // modalWindow


        $('body').append(html);
        $('#dynamicModal').modal();
        $('#dynamicModal').modal('show');

        $('#dynamicModal').on('hidden.bs.modal', function (e) {
            $(this).remove();
        });

    }
}
